<template>
    <header class="main-header">
        <!-- Logo -->
        <router-link to="/dashboard" class="logo">
            <!-- mini logo for sidebar mini 50x50 pixels -->
            <span class="logo-mini"><b>A</b>B</span>
            <!-- logo for regular state and mobile devices -->
            <span class="logo-lg"><b>Admin</b> AB</span>
        </router-link>
        <!-- Header Navbar: style can be found in header.less -->
        <nav class="navbar navbar-static-top">
            <!-- Sidebar toggle button-->


            <div class="navbar-custom-menu">
                <ul class="nav navbar-nav">
                    <li>
                        <a href="#" class="" @click.prevent="logout">Sign out {{ decodeURI(nickname) }}</a>
                    </li>
                    <li>
                        <a href="#" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
  name: 'DashboardHeader',
  data: function () {
    return {
      form: new Form({}),
      nickname: ''
    }
  },
  methods: {
    logout: function () {
      var data = {
        'user_id': localStorage.user_id,
        'token_header': localStorage.token_header,
        'token_log': localStorage.token_log
      }
      this.form.post(baseUrl + 'Home/Logout', data).then(function (result) {
        // success
      }, function (reason) {
        // rejection
      })

      this.$store.commit('REMOVE_TOKEN')

      if (window.localStorage) {
        window.localStorage.removeItem('token_log')
        window.localStorage.removeItem('token_header')
        window.localStorage.removeItem('role')
        window.localStorage.removeItem('user_id')
      }

      this.$router.push('/login')
    }
  },
  mounted: function () {
    var self = this
    this.nickname = this.$store.state.nickname
    setTimeout(function () {
      self.nickname = self.$store.state.nickname
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?28026bd7